import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NoMatch from './components/Utils/NoMatch';
import ProtectedRoutes from './pages/Auth/ProtectedRoutes';
import Login from './pages/Auth/Login';
import Signup from './pages/Auth/Signup';
import Dashboard from './pages/Dashboard/Dashboard';
import Notifications from './pages/Notifications/Notifications';
import ClinicalReports from './pages/ClinicalReports/ClinicalReports';
import Failures from './pages/Failures/Failures';
import SessionManage from './pages/SessionManagement/SessionManage';
import ResetPassword from './pages/Auth/ResetPassword';
import ForgotPassword from './pages/Auth/ForgotPassword';
import { AccessDenied } from './components/Layout/AccessDenied';
import AppointmentMeeting from './pages/ClinicalConsults/AppointmentMeeting';
import ConfirmEmail from './pages/Auth/ConfirmEmail';
import UnsubscribeEmail from './pages/Auth/UnsubscribeEmail';
import UserNotifications from './pages/Settings/UserNotifications';
import Settings from './pages/Settings/Settings';
import SearchPatient from './pages/SearchPatient/SearchPatient';
import PatientResults from './pages/PatientResults/PatientResults';
import PatientCard from './pages/PatientCard/PatientCard';
import PatientRecord from './pages/PatientRecord/PatientRecord';
import AdmitPatient from './pages/AdmitPatient/AdmitPatient';
import { PatientDischarge } from './pages/PatientDischarge/PatientDischarge';
import ReAdmitPatient from './pages/ReAdminPatient/ReAdmitPatient';
import PatientRequestConsultation from './pages/PatientRequestConsultation/PatientRequestConsultation';
import CreateMedOrder from './pages/medOrder/createMedOrder';
import AddNewMedication from './pages/AddNewOrder/AddNewMedication';
import UpdateOrder from './pages/UpdateOrder/UpdateOrder';
import PatientAllergies from './pages/PatientAllergies/PatientAllergies';
import PatientDiagnosis from './pages/PatientDiagnosis/PatientDiagnosis';
import PatientApproveMedications from './pages/PatientApproveMedications/PatientApproveMedications';
import ApproveMedications from './pages/ApproveMedications/ApproveMedications';
import PendingOrder from './pages/PendingOrder/PendingOrder';
import MedHistory from './pages/MedOrderHistory/MedHistory';
import PatientPrescriptions from './pages/PatientPrescriptions/PatientPrescriptions';
import OrganizationsView from './pages/Organizations/OrganizationsView';
import OrganizationUsersView from './pages/Organizations/OrganizationUsersView';
import OrganizationUserImport from './pages/Organizations/OrganizationUserImport';
import OrganizationUserUpdate from './pages/Organizations/OrganizationUserUpdate';
import OrganizationOrderSets from './pages/OrderSets/OrganizationOrderSets';
import CreateOrderTemplate from './pages/OrderSets/CreateOrderTemplate';

const App = ({ theme }) => {
    useEffect(() => {
        window.process = { ...window.process };
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<ProtectedRoutes />}>
                    <Route path="/organizations" element={<OrganizationsView />} />

                    <Route path="/organizations/:id/users" element={<OrganizationUsersView />} />

                    <Route path="/organizations/:id/order-sets" element={<OrganizationOrderSets />} />
                    <Route path="/organizations/:id/order-sets/:orderSetId/med-create" element={<CreateOrderTemplate />} />

                    <Route path="/organizations/:id/users/import" element={<OrganizationUserImport />} />
                    <Route path="/organizations/:id/users/:userId/update" element={<OrganizationUserUpdate />} />
                    
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/admit_patient" element={<AdmitPatient />} />
                    <Route path="/search-patient" element={<SearchPatient />} />
                    <Route
                        path="/patient-results"
                        element={<PatientResults />}
                    />
                    <Route
                        path="/patient/:id/re-admit"
                        element={<ReAdmitPatient />}
                    />
                    <Route path="/patient/:id" element={<PatientCard />} />
                    <Route
                        path="/patient_record/:id"
                        element={<PatientRecord />}
                    />
                    <Route
                        path="/patient-discharge/:id"
                        element={<PatientDischarge />}
                    />
                    <Route
                        path="/patient/:id/clinical-consultation"
                        element={<PatientRequestConsultation />}
                    />
                    <Route
                        path="/patient/:id/add-new-medication"
                        element={<AddNewMedication />}
                    />
                    <Route
                        path="/patient/:id/medications-history"
                        element={<MedHistory />}
                    />
                    <Route
                        path="/patient/:id/allergies"
                        element={<PatientAllergies />}
                    />
                    <Route
                        path="/patient/:id/diagnosis"
                        element={<PatientDiagnosis />}
                    />
                    <Route
                        path="/patient/:id/approve-medications/:from"
                        element={<PatientApproveMedications />}
                    />
                    <Route
                        path="/patient/:id/add-approve-medication/:medicationId/:orderId"
                        element={<ApproveMedications />}
                    />
                    <Route
                        path="/patient/:id/prescriptions"
                        element={<PatientPrescriptions />}
                    />
                    <Route
                        path="/patient/:id/update-medication/:orderId"
                        element={<UpdateOrder />}
                    />
                    <Route
                        path="/patient/:id/med-order-create"
                        element={<CreateMedOrder />}
                    />
                    <Route
                        path="/patient/:id/pending-order/:orderId"
                        element={<PendingOrder />}
                    />
                    <Route path="/account-team">
                        <Route
                            path="notifications"
                            element={<Notifications />}
                        />
                        <Route
                            path="data-integration-failures"
                            element={<Failures />}
                        />
                        <Route
                            path="device-session-management"
                            element={<SessionManage />}
                        />
                    </Route>
                    <Route path="/reporting">
                        <Route
                            path="clinical-report"
                            element={<ClinicalReports />}
                        />
                    </Route>
                    <Route path="/clinical-team">
                        <Route
                            path="clinical-consults"
                            element={<AppointmentMeeting />}
                        />
                    </Route>
                    <Route path="/settings">
                        <Route index element={<Settings />} />
                        <Route
                            path="notifications"
                            element={<UserNotifications />}
                        />
                    </Route>
                    <Route path="*" element={<NoMatch />} />
                </Route>
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/access-denied" element={<AccessDenied />} />
                <Route
                    path="/account/reset-password"
                    element={<ResetPassword />}
                />
                <Route
                    path="/account/forgot-password"
                    element={<ForgotPassword />}
                />
                <Route
                    path="/communication/preferences/confirm-email"
                    element={<ConfirmEmail />}
                />
                <Route
                    path="/communication/preferences/unsubscribe-email"
                    element={<UnsubscribeEmail />}
                />
                <Route path="*" element={<NoMatch />} />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
